import * as Types from '../../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetDashCardCountQueryVariables = Types.Exact<{
  request: Types.EimDashboardRequest;
}>;


export type GetDashCardCountQuery = { __typename?: 'Query', getDashCardCount?: { __typename?: 'EIMDashboardCardsResponse', total?: number | null, inbound?: number | null, outbound?: number | null, pass?: number | null, overdue?: number | null, fail?: number | null, transit?: number | null, transb?: number | null } | null };

export type CountAllActivePartnersQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CountAllActivePartnersQuery = { __typename?: 'Query', countAllActivePartnerData?: { __typename?: 'EIMDashboardActivePartnerCountResponse', total?: number | null, groupCountData?: Array<{ __typename?: 'ActivePartnerGroupCountData', group_id?: number | null, group_name?: string | null, total_active_partner?: number | null }> | null } | null };

export type AllActivePartnersQueryVariables = Types.Exact<{
  request: Types.EimDashboardRequest;
}>;


export type AllActivePartnersQuery = { __typename?: 'Query', allActivePartnerData?: Array<{ __typename?: 'EIMDashboardActivePartnerResponse', month?: string | null, company?: string | null, partnerno?: string | null, group?: string | null, total?: number | null }> | null };

export type DownloadAllActivePartnersQueryVariables = Types.Exact<{
  request: Types.EimDashboardRequest;
}>;


export type DownloadAllActivePartnersQuery = { __typename?: 'Query', allActivePartnerDataDownload?: { __typename?: 'EIMDashboardActivePartnerResponse', month?: string | null, company?: string | null, partnerno?: string | null, group?: string | null, total?: number | null } | null };

export type AllPartnersByPartnerNoQueryVariables = Types.Exact<{
  partnerNo: Types.Scalars['String']['input'];
}>;


export type AllPartnersByPartnerNoQuery = { __typename?: 'Query', allPartnersByPartnerNo?: Array<{ __typename?: 'AssignedPartner', partnerNo?: string | null, partnerName?: string | null, systemCode?: string | null, companyCode?: string | null }> | null };

export type AllActivePartnerInvoiceSummaryQueryVariables = Types.Exact<{
  request: Types.EimDashboardRequest;
}>;


export type AllActivePartnerInvoiceSummaryQuery = { __typename?: 'Query', allActivePartnerInvoiceSummary?: Array<{ __typename?: 'EIMDashboardPartnerInvoiceSummaryResponse', partnerno?: string | null, partnerName?: string | null, company?: string | null, total?: number | null }> | null };

export type AllActivePartnerInvoiceHourlyTrendQueryVariables = Types.Exact<{
  request: Types.EimDashboardRequest;
}>;


export type AllActivePartnerInvoiceHourlyTrendQuery = { __typename?: 'Query', allActivePartnerInvoiceHourlyTrend?: Array<{ __typename?: 'EIMDashboardPartnerInvoiceHourlyTrendResponse', hourLabel?: string | null, successfulCount?: number | null, failedCount?: number | null }> | null };

export type AllActivePartnerCountryDetailQueryVariables = Types.Exact<{
  request: Types.EimDashboardRequest;
}>;


export type AllActivePartnerCountryDetailQuery = { __typename?: 'Query', allActivePartnerCountryDetail?: { __typename?: 'EIMDashboardCountryDetailResponse', metrics?: { __typename?: 'EIMDashboardCountryDetailMetricsResponse', totalProcessed?: number | null, successfulCount?: number | null, failedCount?: number | null, overdueCount?: number | null, inTransitCount?: number | null, stpRate?: number | null, failureRate?: number | null, avgTransitDays?: number | null } | null, topPartners?: Array<{ __typename?: 'EIMDashboardPartnerInvoiceSummaryResponse', partnerno?: string | null, partnerName?: string | null, company?: string | null, total?: number | null }> | null, hourlyTrend?: Array<{ __typename?: 'EIMDashboardPartnerInvoiceHourlyTrendResponse', hourLabel?: string | null, successfulCount?: number | null, failedCount?: number | null }> | null, topErrorMessages?: Array<{ __typename?: 'EIMDashboardCountryDetailErrorMessageResponse', message?: string | null, count?: number | null, percentage?: number | null }> | null } | null };

export type AllActivePartnerCountryMetricsQueryVariables = Types.Exact<{
  request: Types.EimDashboardRequest;
}>;


export type AllActivePartnerCountryMetricsQuery = { __typename?: 'Query', allActivePartnerCountryMetrics?: Array<{ __typename?: 'CountryMetricsSummary', country: string, companyCode: string, intake: { __typename?: 'IntakeMetricsSummary', totalProcessed: number, inboundCount: number, outboundCount: number }, processing: { __typename?: 'ProcessingMetricsSummary', stpRate: number, onTimeRate: number, avgTransitDays: number, inTransitCount: number }, exceptions: { __typename?: 'ExceptionMetricsSummary', failedCount: number, overdueCount: number, failureRate: number }, coverage: { __typename?: 'CoverageMetricsSummary', activePartners: number, totalPartners: number, coverageRate: number } }> | null };

export type EimExecutiveDashboardQueryVariables = Types.Exact<{
  request: Types.EimExecutiveDashboardRequest;
}>;


export type EimExecutiveDashboardQuery = { __typename?: 'Query', eimExecutiveDashboard?: { __typename?: 'EIMExecutiveDashboardResponse', volume: { __typename?: 'VolumeSectionMetrics', totalProcessed: number, inboundCount: number, outboundCount: number, previousPeriodTotal: number, volumeDelta: number, failedCount: number, inTransitCount: number, busnTransitCount: number, failureRate: number, failureRateTarget: number, failureRateThreshold: number, volumeTrendByMonth: Array<{ __typename?: 'VolumeTrendPoint', month: string, total: number, failed: number, stpRate: number }> }, flowHealth: { __typename?: 'FlowHealthSectionMetrics', stpRate: number, previousStpRate: number, stpDelta: number, stpTarget: number, stpThreshold: number, onTimeRate: number, previousOnTimeRate: number, onTimeDelta: number, onTimeTarget: number, onTimeThreshold: number, avgTransitDays: number, previousAvgTransitDays: number, transitDelta: string, stpRateTrendByMonth: Array<{ __typename?: 'FlowHealthTrendPoint', month: string, stpRate: number, onTimeRate: number, avgTransitDays: number }>, stpRateTrendByDay: Array<{ __typename?: 'FlowHealthTrendPoint', month: string, stpRate: number, onTimeRate: number, avgTransitDays: number }>, stpRateTrendByYear: Array<{ __typename?: 'FlowHealthTrendPoint', month: string, stpRate: number, onTimeRate: number, avgTransitDays: number }> }, risk: { __typename?: 'RiskSectionMetrics', overdueCount: number, previousOverdueCount: number, overdueDelta: number, overdueTarget: number, overdueThreshold: number, failedCount: number, failureRate: number, previousFailureRate: number, failureRateDelta: number, failureRateTarget: number, failureRateThreshold: number, agingBuckets: Array<{ __typename?: 'AgingBucket', ageRange: string, count: number, percentage: number }>, overdueTrendByMonth: Array<{ __typename?: 'OverdueTrendPoint', month: string, overdueCount: number }> }, coverage: { __typename?: 'CoverageSectionMetrics', activePartners: number, totalPartners: number, coverageRate: number, previousCoverageRate: number, coverageDelta: number, coverageTarget: number, coverageThreshold: number, monthlyNewPartners: number, topImpactedGroups: Array<{ __typename?: 'TopImpactedGroup', groupName: string, failureRate: number, overdueCount: number, volume: number, riskRanking: number }>, coverageTrendByMonth: Array<{ __typename?: 'CoverageTrendPoint', month: string, coverageRate: number, activePartnerCount: number }> }, metadata: { __typename?: 'DashboardMetadata', dataAsOf: any, lastRefresh: any, compositeHealthScore?: number | null, healthScoreLabel?: string | null, appliedFilters: { __typename?: 'DashboardAppliedFilters', periodStart: any, periodEnd: any, processType?: string | null, partnerGroup?: string | null } } } | null };

export type EimExecutiveDashboardV2QueryVariables = Types.Exact<{
  request: Types.EimExecutiveDashboardRequest;
}>;


export type EimExecutiveDashboardV2Query = { __typename?: 'Query', eimExecutiveDashboard?: { __typename?: 'EIMExecutiveDashboardResponse', volume: { __typename?: 'VolumeSectionMetrics', totalProcessed: number }, flowHealth: { __typename?: 'FlowHealthSectionMetrics', onTimeRate: number, onTimeDelta: number, avgTransitDays: number }, coverage: { __typename?: 'CoverageSectionMetrics', coverageRate: number, coverageThreshold: number }, metadata: { __typename?: 'DashboardMetadata', healthScoreLabel?: string | null } } | null };

export type EimExecutiveDashboardCountryMetricsQueryVariables = Types.Exact<{
  request: Types.EimExecutiveDashboardRequest;
}>;


export type EimExecutiveDashboardCountryMetricsQuery = { __typename?: 'Query', eimExecutiveDashboardCountryMetrics: Array<{ __typename?: 'CountryMetricsSummary', country: string, companyCode: string, intake: { __typename?: 'IntakeMetricsSummary', totalProcessed: number, inboundCount: number, outboundCount: number }, processing: { __typename?: 'ProcessingMetricsSummary', stpRate: number, onTimeRate: number, avgTransitDays: number, inTransitCount: number }, exceptions: { __typename?: 'ExceptionMetricsSummary', failedCount: number, overdueCount: number, failureRate: number }, coverage: { __typename?: 'CoverageMetricsSummary', activePartners: number, totalPartners: number, coverageRate: number } }> };

export type EimExecutiveDashboardSystemMetricsQueryVariables = Types.Exact<{
  request: Types.EimExecutiveDashboardRequest;
}>;


export type EimExecutiveDashboardSystemMetricsQuery = { __typename?: 'Query', eimExecutiveDashboardSystemMetrics: Array<{ __typename?: 'SystemMetricsSummary', systemId?: number | null, systemLabel: string, intake: { __typename?: 'IntakeMetricsSummary', totalProcessed: number, inboundCount: number, outboundCount: number }, processing: { __typename?: 'ProcessingMetricsSummary', stpRate: number, onTimeRate: number, avgTransitDays: number, inTransitCount: number }, exceptions: { __typename?: 'ExceptionMetricsSummary', failedCount: number, overdueCount: number, failureRate: number }, coverage: { __typename?: 'CoverageMetricsSummary', activePartners: number, totalPartners: number, coverageRate: number } }> };

export type EimExecutiveDashboardChannelMetricsQueryVariables = Types.Exact<{
  request: Types.EimExecutiveDashboardRequest;
}>;


export type EimExecutiveDashboardChannelMetricsQuery = { __typename?: 'Query', eimExecutiveDashboardChannelMetrics: Array<{ __typename?: 'ChannelMetricsSummary', channel: string, intake: { __typename?: 'IntakeMetricsSummary', totalProcessed: number, inboundCount: number, outboundCount: number }, processing: { __typename?: 'ProcessingMetricsSummary', stpRate: number, onTimeRate: number, avgTransitDays: number, inTransitCount: number }, exceptions: { __typename?: 'ExceptionMetricsSummary', failedCount: number, overdueCount: number, failureRate: number }, coverage: { __typename?: 'CoverageMetricsSummary', activePartners: number, totalPartners: number, coverageRate: number } }> };

export type EimExecutiveDashboardFlowStageMetricsQueryVariables = Types.Exact<{
  request: Types.EimExecutiveDashboardRequest;
}>;


export type EimExecutiveDashboardFlowStageMetricsQuery = { __typename?: 'Query', eimExecutiveDashboardFlowStageMetrics: Array<{ __typename?: 'FlowStageMetricsSummary', mProcess: string, stage: string, stepNumber?: number | null, transitionCount: number, avgTransitDays: number }> };

export type EimExecutiveDashboardGroupMetricsQueryVariables = Types.Exact<{
  request: Types.EimExecutiveDashboardRequest;
}>;


export type EimExecutiveDashboardGroupMetricsQuery = { __typename?: 'Query', eimExecutiveDashboardGroupMetrics: Array<{ __typename?: 'GroupMetricsSummary', groupName: string, country: string, totalInvoices: number, successfulCount: number, inTransitCount: number, failedCount: number }> };

export type EimExecutiveDashboardTopFailureReasonsQueryVariables = Types.Exact<{
  request: Types.EimExecutiveDashboardRequest;
}>;


export type EimExecutiveDashboardTopFailureReasonsQuery = { __typename?: 'Query', eimExecutiveDashboardTopFailureReasons: Array<{ __typename?: 'FailureReasonSummary', reason: string, invoiceCount: number, percentage: number, failedCount: number, failureRate: number, overdueCount: number, volume: number }> };

export type EimExecutiveDashboardTopFailureProcessesQueryVariables = Types.Exact<{
  request: Types.EimExecutiveDashboardRequest;
}>;


export type EimExecutiveDashboardTopFailureProcessesQuery = { __typename?: 'Query', eimExecutiveDashboardTopFailureProcesses: Array<{ __typename?: 'TopFailureProcessSummary', process: string, failedCount: number, totalCount: number, failureRate: number, overdueCount: number }> };

export type EimExecutiveDashboardTopFailureCompanyCodesQueryVariables = Types.Exact<{
  request: Types.EimExecutiveDashboardRequest;
}>;


export type EimExecutiveDashboardTopFailureCompanyCodesQuery = { __typename?: 'Query', eimExecutiveDashboardTopFailureCompanyCodes: Array<{ __typename?: 'TopFailureCompanySummary', companyCode: string, country: string, failureRate: number, overdueCount: number, volume: number, riskRanking: number }> };


export const GetDashCardCountDocument = gql`
    query getDashCardCount($request: EIMDashboardRequest!) {
  getDashCardCount(request: $request) {
    total
    inbound
    outbound
    pass
    overdue
    fail
    transit
    transb
  }
}
    `;

/**
 * __useGetDashCardCountQuery__
 *
 * To run a query within a React component, call `useGetDashCardCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashCardCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashCardCountQuery({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useGetDashCardCountQuery(baseOptions: Apollo.QueryHookOptions<GetDashCardCountQuery, GetDashCardCountQueryVariables> & ({ variables: GetDashCardCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDashCardCountQuery, GetDashCardCountQueryVariables>(GetDashCardCountDocument, options);
      }
export function useGetDashCardCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDashCardCountQuery, GetDashCardCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDashCardCountQuery, GetDashCardCountQueryVariables>(GetDashCardCountDocument, options);
        }
// @ts-ignore
export function useGetDashCardCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDashCardCountQuery, GetDashCardCountQueryVariables>): Apollo.UseSuspenseQueryResult<GetDashCardCountQuery, GetDashCardCountQueryVariables>;
export function useGetDashCardCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDashCardCountQuery, GetDashCardCountQueryVariables>): Apollo.UseSuspenseQueryResult<GetDashCardCountQuery | undefined, GetDashCardCountQueryVariables>;
export function useGetDashCardCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDashCardCountQuery, GetDashCardCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDashCardCountQuery, GetDashCardCountQueryVariables>(GetDashCardCountDocument, options);
        }
export type GetDashCardCountQueryHookResult = ReturnType<typeof useGetDashCardCountQuery>;
export type GetDashCardCountLazyQueryHookResult = ReturnType<typeof useGetDashCardCountLazyQuery>;
export type GetDashCardCountSuspenseQueryHookResult = ReturnType<typeof useGetDashCardCountSuspenseQuery>;
export type GetDashCardCountQueryResult = Apollo.QueryResult<GetDashCardCountQuery, GetDashCardCountQueryVariables>;
export const CountAllActivePartnersDocument = gql`
    query countAllActivePartners {
  countAllActivePartnerData {
    total
    groupCountData {
      group_id
      group_name
      total_active_partner
    }
  }
}
    `;

/**
 * __useCountAllActivePartnersQuery__
 *
 * To run a query within a React component, call `useCountAllActivePartnersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountAllActivePartnersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountAllActivePartnersQuery({
 *   variables: {
 *   },
 * });
 */
export function useCountAllActivePartnersQuery(baseOptions?: Apollo.QueryHookOptions<CountAllActivePartnersQuery, CountAllActivePartnersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountAllActivePartnersQuery, CountAllActivePartnersQueryVariables>(CountAllActivePartnersDocument, options);
      }
export function useCountAllActivePartnersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountAllActivePartnersQuery, CountAllActivePartnersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountAllActivePartnersQuery, CountAllActivePartnersQueryVariables>(CountAllActivePartnersDocument, options);
        }
// @ts-ignore
export function useCountAllActivePartnersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountAllActivePartnersQuery, CountAllActivePartnersQueryVariables>): Apollo.UseSuspenseQueryResult<CountAllActivePartnersQuery, CountAllActivePartnersQueryVariables>;
export function useCountAllActivePartnersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CountAllActivePartnersQuery, CountAllActivePartnersQueryVariables>): Apollo.UseSuspenseQueryResult<CountAllActivePartnersQuery | undefined, CountAllActivePartnersQueryVariables>;
export function useCountAllActivePartnersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CountAllActivePartnersQuery, CountAllActivePartnersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountAllActivePartnersQuery, CountAllActivePartnersQueryVariables>(CountAllActivePartnersDocument, options);
        }
export type CountAllActivePartnersQueryHookResult = ReturnType<typeof useCountAllActivePartnersQuery>;
export type CountAllActivePartnersLazyQueryHookResult = ReturnType<typeof useCountAllActivePartnersLazyQuery>;
export type CountAllActivePartnersSuspenseQueryHookResult = ReturnType<typeof useCountAllActivePartnersSuspenseQuery>;
export type CountAllActivePartnersQueryResult = Apollo.QueryResult<CountAllActivePartnersQuery, CountAllActivePartnersQueryVariables>;
export const AllActivePartnersDocument = gql`
    query AllActivePartners($request: EIMDashboardRequest!) {
  allActivePartnerData(request: $request) {
    month
    company
    partnerno
    group
    total
  }
}
    `;

/**
 * __useAllActivePartnersQuery__
 *
 * To run a query within a React component, call `useAllActivePartnersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllActivePartnersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllActivePartnersQuery({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useAllActivePartnersQuery(baseOptions: Apollo.QueryHookOptions<AllActivePartnersQuery, AllActivePartnersQueryVariables> & ({ variables: AllActivePartnersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllActivePartnersQuery, AllActivePartnersQueryVariables>(AllActivePartnersDocument, options);
      }
export function useAllActivePartnersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllActivePartnersQuery, AllActivePartnersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllActivePartnersQuery, AllActivePartnersQueryVariables>(AllActivePartnersDocument, options);
        }
// @ts-ignore
export function useAllActivePartnersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllActivePartnersQuery, AllActivePartnersQueryVariables>): Apollo.UseSuspenseQueryResult<AllActivePartnersQuery, AllActivePartnersQueryVariables>;
export function useAllActivePartnersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllActivePartnersQuery, AllActivePartnersQueryVariables>): Apollo.UseSuspenseQueryResult<AllActivePartnersQuery | undefined, AllActivePartnersQueryVariables>;
export function useAllActivePartnersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllActivePartnersQuery, AllActivePartnersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllActivePartnersQuery, AllActivePartnersQueryVariables>(AllActivePartnersDocument, options);
        }
export type AllActivePartnersQueryHookResult = ReturnType<typeof useAllActivePartnersQuery>;
export type AllActivePartnersLazyQueryHookResult = ReturnType<typeof useAllActivePartnersLazyQuery>;
export type AllActivePartnersSuspenseQueryHookResult = ReturnType<typeof useAllActivePartnersSuspenseQuery>;
export type AllActivePartnersQueryResult = Apollo.QueryResult<AllActivePartnersQuery, AllActivePartnersQueryVariables>;
export const DownloadAllActivePartnersDocument = gql`
    query DownloadAllActivePartners($request: EIMDashboardRequest!) {
  allActivePartnerDataDownload(request: $request) {
    month
    company
    partnerno
    group
    total
  }
}
    `;

/**
 * __useDownloadAllActivePartnersQuery__
 *
 * To run a query within a React component, call `useDownloadAllActivePartnersQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadAllActivePartnersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadAllActivePartnersQuery({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useDownloadAllActivePartnersQuery(baseOptions: Apollo.QueryHookOptions<DownloadAllActivePartnersQuery, DownloadAllActivePartnersQueryVariables> & ({ variables: DownloadAllActivePartnersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadAllActivePartnersQuery, DownloadAllActivePartnersQueryVariables>(DownloadAllActivePartnersDocument, options);
      }
export function useDownloadAllActivePartnersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadAllActivePartnersQuery, DownloadAllActivePartnersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadAllActivePartnersQuery, DownloadAllActivePartnersQueryVariables>(DownloadAllActivePartnersDocument, options);
        }
// @ts-ignore
export function useDownloadAllActivePartnersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DownloadAllActivePartnersQuery, DownloadAllActivePartnersQueryVariables>): Apollo.UseSuspenseQueryResult<DownloadAllActivePartnersQuery, DownloadAllActivePartnersQueryVariables>;
export function useDownloadAllActivePartnersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DownloadAllActivePartnersQuery, DownloadAllActivePartnersQueryVariables>): Apollo.UseSuspenseQueryResult<DownloadAllActivePartnersQuery | undefined, DownloadAllActivePartnersQueryVariables>;
export function useDownloadAllActivePartnersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DownloadAllActivePartnersQuery, DownloadAllActivePartnersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DownloadAllActivePartnersQuery, DownloadAllActivePartnersQueryVariables>(DownloadAllActivePartnersDocument, options);
        }
export type DownloadAllActivePartnersQueryHookResult = ReturnType<typeof useDownloadAllActivePartnersQuery>;
export type DownloadAllActivePartnersLazyQueryHookResult = ReturnType<typeof useDownloadAllActivePartnersLazyQuery>;
export type DownloadAllActivePartnersSuspenseQueryHookResult = ReturnType<typeof useDownloadAllActivePartnersSuspenseQuery>;
export type DownloadAllActivePartnersQueryResult = Apollo.QueryResult<DownloadAllActivePartnersQuery, DownloadAllActivePartnersQueryVariables>;
export const AllPartnersByPartnerNoDocument = gql`
    query allPartnersByPartnerNo($partnerNo: String!) {
  allPartnersByPartnerNo(partnerNo: $partnerNo) {
    partnerNo
    partnerName
    systemCode
    companyCode
  }
}
    `;

/**
 * __useAllPartnersByPartnerNoQuery__
 *
 * To run a query within a React component, call `useAllPartnersByPartnerNoQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPartnersByPartnerNoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPartnersByPartnerNoQuery({
 *   variables: {
 *      partnerNo: // value for 'partnerNo'
 *   },
 * });
 */
export function useAllPartnersByPartnerNoQuery(baseOptions: Apollo.QueryHookOptions<AllPartnersByPartnerNoQuery, AllPartnersByPartnerNoQueryVariables> & ({ variables: AllPartnersByPartnerNoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllPartnersByPartnerNoQuery, AllPartnersByPartnerNoQueryVariables>(AllPartnersByPartnerNoDocument, options);
      }
export function useAllPartnersByPartnerNoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllPartnersByPartnerNoQuery, AllPartnersByPartnerNoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllPartnersByPartnerNoQuery, AllPartnersByPartnerNoQueryVariables>(AllPartnersByPartnerNoDocument, options);
        }
// @ts-ignore
export function useAllPartnersByPartnerNoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllPartnersByPartnerNoQuery, AllPartnersByPartnerNoQueryVariables>): Apollo.UseSuspenseQueryResult<AllPartnersByPartnerNoQuery, AllPartnersByPartnerNoQueryVariables>;
export function useAllPartnersByPartnerNoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllPartnersByPartnerNoQuery, AllPartnersByPartnerNoQueryVariables>): Apollo.UseSuspenseQueryResult<AllPartnersByPartnerNoQuery | undefined, AllPartnersByPartnerNoQueryVariables>;
export function useAllPartnersByPartnerNoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllPartnersByPartnerNoQuery, AllPartnersByPartnerNoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllPartnersByPartnerNoQuery, AllPartnersByPartnerNoQueryVariables>(AllPartnersByPartnerNoDocument, options);
        }
export type AllPartnersByPartnerNoQueryHookResult = ReturnType<typeof useAllPartnersByPartnerNoQuery>;
export type AllPartnersByPartnerNoLazyQueryHookResult = ReturnType<typeof useAllPartnersByPartnerNoLazyQuery>;
export type AllPartnersByPartnerNoSuspenseQueryHookResult = ReturnType<typeof useAllPartnersByPartnerNoSuspenseQuery>;
export type AllPartnersByPartnerNoQueryResult = Apollo.QueryResult<AllPartnersByPartnerNoQuery, AllPartnersByPartnerNoQueryVariables>;
export const AllActivePartnerInvoiceSummaryDocument = gql`
    query allActivePartnerInvoiceSummary($request: EIMDashboardRequest!) {
  allActivePartnerInvoiceSummary(request: $request) {
    partnerno
    partnerName
    company
    total
  }
}
    `;

/**
 * __useAllActivePartnerInvoiceSummaryQuery__
 *
 * To run a query within a React component, call `useAllActivePartnerInvoiceSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllActivePartnerInvoiceSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllActivePartnerInvoiceSummaryQuery({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useAllActivePartnerInvoiceSummaryQuery(baseOptions: Apollo.QueryHookOptions<AllActivePartnerInvoiceSummaryQuery, AllActivePartnerInvoiceSummaryQueryVariables> & ({ variables: AllActivePartnerInvoiceSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllActivePartnerInvoiceSummaryQuery, AllActivePartnerInvoiceSummaryQueryVariables>(AllActivePartnerInvoiceSummaryDocument, options);
      }
export function useAllActivePartnerInvoiceSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllActivePartnerInvoiceSummaryQuery, AllActivePartnerInvoiceSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllActivePartnerInvoiceSummaryQuery, AllActivePartnerInvoiceSummaryQueryVariables>(AllActivePartnerInvoiceSummaryDocument, options);
        }
// @ts-ignore
export function useAllActivePartnerInvoiceSummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllActivePartnerInvoiceSummaryQuery, AllActivePartnerInvoiceSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<AllActivePartnerInvoiceSummaryQuery, AllActivePartnerInvoiceSummaryQueryVariables>;
export function useAllActivePartnerInvoiceSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllActivePartnerInvoiceSummaryQuery, AllActivePartnerInvoiceSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<AllActivePartnerInvoiceSummaryQuery | undefined, AllActivePartnerInvoiceSummaryQueryVariables>;
export function useAllActivePartnerInvoiceSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllActivePartnerInvoiceSummaryQuery, AllActivePartnerInvoiceSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllActivePartnerInvoiceSummaryQuery, AllActivePartnerInvoiceSummaryQueryVariables>(AllActivePartnerInvoiceSummaryDocument, options);
        }
export type AllActivePartnerInvoiceSummaryQueryHookResult = ReturnType<typeof useAllActivePartnerInvoiceSummaryQuery>;
export type AllActivePartnerInvoiceSummaryLazyQueryHookResult = ReturnType<typeof useAllActivePartnerInvoiceSummaryLazyQuery>;
export type AllActivePartnerInvoiceSummarySuspenseQueryHookResult = ReturnType<typeof useAllActivePartnerInvoiceSummarySuspenseQuery>;
export type AllActivePartnerInvoiceSummaryQueryResult = Apollo.QueryResult<AllActivePartnerInvoiceSummaryQuery, AllActivePartnerInvoiceSummaryQueryVariables>;
export const AllActivePartnerInvoiceHourlyTrendDocument = gql`
    query allActivePartnerInvoiceHourlyTrend($request: EIMDashboardRequest!) {
  allActivePartnerInvoiceHourlyTrend(request: $request) {
    hourLabel
    successfulCount
    failedCount
  }
}
    `;

/**
 * __useAllActivePartnerInvoiceHourlyTrendQuery__
 *
 * To run a query within a React component, call `useAllActivePartnerInvoiceHourlyTrendQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllActivePartnerInvoiceHourlyTrendQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllActivePartnerInvoiceHourlyTrendQuery({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useAllActivePartnerInvoiceHourlyTrendQuery(baseOptions: Apollo.QueryHookOptions<AllActivePartnerInvoiceHourlyTrendQuery, AllActivePartnerInvoiceHourlyTrendQueryVariables> & ({ variables: AllActivePartnerInvoiceHourlyTrendQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllActivePartnerInvoiceHourlyTrendQuery, AllActivePartnerInvoiceHourlyTrendQueryVariables>(AllActivePartnerInvoiceHourlyTrendDocument, options);
      }
export function useAllActivePartnerInvoiceHourlyTrendLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllActivePartnerInvoiceHourlyTrendQuery, AllActivePartnerInvoiceHourlyTrendQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllActivePartnerInvoiceHourlyTrendQuery, AllActivePartnerInvoiceHourlyTrendQueryVariables>(AllActivePartnerInvoiceHourlyTrendDocument, options);
        }
// @ts-ignore
export function useAllActivePartnerInvoiceHourlyTrendSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllActivePartnerInvoiceHourlyTrendQuery, AllActivePartnerInvoiceHourlyTrendQueryVariables>): Apollo.UseSuspenseQueryResult<AllActivePartnerInvoiceHourlyTrendQuery, AllActivePartnerInvoiceHourlyTrendQueryVariables>;
export function useAllActivePartnerInvoiceHourlyTrendSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllActivePartnerInvoiceHourlyTrendQuery, AllActivePartnerInvoiceHourlyTrendQueryVariables>): Apollo.UseSuspenseQueryResult<AllActivePartnerInvoiceHourlyTrendQuery | undefined, AllActivePartnerInvoiceHourlyTrendQueryVariables>;
export function useAllActivePartnerInvoiceHourlyTrendSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllActivePartnerInvoiceHourlyTrendQuery, AllActivePartnerInvoiceHourlyTrendQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllActivePartnerInvoiceHourlyTrendQuery, AllActivePartnerInvoiceHourlyTrendQueryVariables>(AllActivePartnerInvoiceHourlyTrendDocument, options);
        }
export type AllActivePartnerInvoiceHourlyTrendQueryHookResult = ReturnType<typeof useAllActivePartnerInvoiceHourlyTrendQuery>;
export type AllActivePartnerInvoiceHourlyTrendLazyQueryHookResult = ReturnType<typeof useAllActivePartnerInvoiceHourlyTrendLazyQuery>;
export type AllActivePartnerInvoiceHourlyTrendSuspenseQueryHookResult = ReturnType<typeof useAllActivePartnerInvoiceHourlyTrendSuspenseQuery>;
export type AllActivePartnerInvoiceHourlyTrendQueryResult = Apollo.QueryResult<AllActivePartnerInvoiceHourlyTrendQuery, AllActivePartnerInvoiceHourlyTrendQueryVariables>;
export const AllActivePartnerCountryDetailDocument = gql`
    query allActivePartnerCountryDetail($request: EIMDashboardRequest!) {
  allActivePartnerCountryDetail(request: $request) {
    metrics {
      totalProcessed
      successfulCount
      failedCount
      overdueCount
      inTransitCount
      stpRate
      failureRate
      avgTransitDays
    }
    topPartners {
      partnerno
      partnerName
      company
      total
    }
    hourlyTrend {
      hourLabel
      successfulCount
      failedCount
    }
    topErrorMessages {
      message
      count
      percentage
    }
  }
}
    `;

/**
 * __useAllActivePartnerCountryDetailQuery__
 *
 * To run a query within a React component, call `useAllActivePartnerCountryDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllActivePartnerCountryDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllActivePartnerCountryDetailQuery({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useAllActivePartnerCountryDetailQuery(baseOptions: Apollo.QueryHookOptions<AllActivePartnerCountryDetailQuery, AllActivePartnerCountryDetailQueryVariables> & ({ variables: AllActivePartnerCountryDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllActivePartnerCountryDetailQuery, AllActivePartnerCountryDetailQueryVariables>(AllActivePartnerCountryDetailDocument, options);
      }
export function useAllActivePartnerCountryDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllActivePartnerCountryDetailQuery, AllActivePartnerCountryDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllActivePartnerCountryDetailQuery, AllActivePartnerCountryDetailQueryVariables>(AllActivePartnerCountryDetailDocument, options);
        }
// @ts-ignore
export function useAllActivePartnerCountryDetailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllActivePartnerCountryDetailQuery, AllActivePartnerCountryDetailQueryVariables>): Apollo.UseSuspenseQueryResult<AllActivePartnerCountryDetailQuery, AllActivePartnerCountryDetailQueryVariables>;
export function useAllActivePartnerCountryDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllActivePartnerCountryDetailQuery, AllActivePartnerCountryDetailQueryVariables>): Apollo.UseSuspenseQueryResult<AllActivePartnerCountryDetailQuery | undefined, AllActivePartnerCountryDetailQueryVariables>;
export function useAllActivePartnerCountryDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllActivePartnerCountryDetailQuery, AllActivePartnerCountryDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllActivePartnerCountryDetailQuery, AllActivePartnerCountryDetailQueryVariables>(AllActivePartnerCountryDetailDocument, options);
        }
export type AllActivePartnerCountryDetailQueryHookResult = ReturnType<typeof useAllActivePartnerCountryDetailQuery>;
export type AllActivePartnerCountryDetailLazyQueryHookResult = ReturnType<typeof useAllActivePartnerCountryDetailLazyQuery>;
export type AllActivePartnerCountryDetailSuspenseQueryHookResult = ReturnType<typeof useAllActivePartnerCountryDetailSuspenseQuery>;
export type AllActivePartnerCountryDetailQueryResult = Apollo.QueryResult<AllActivePartnerCountryDetailQuery, AllActivePartnerCountryDetailQueryVariables>;
export const AllActivePartnerCountryMetricsDocument = gql`
    query allActivePartnerCountryMetrics($request: EIMDashboardRequest!) {
  allActivePartnerCountryMetrics(request: $request) {
    country
    companyCode
    intake {
      totalProcessed
      inboundCount
      outboundCount
    }
    processing {
      stpRate
      onTimeRate
      avgTransitDays
      inTransitCount
    }
    exceptions {
      failedCount
      overdueCount
      failureRate
    }
    coverage {
      activePartners
      totalPartners
      coverageRate
    }
  }
}
    `;

/**
 * __useAllActivePartnerCountryMetricsQuery__
 *
 * To run a query within a React component, call `useAllActivePartnerCountryMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllActivePartnerCountryMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllActivePartnerCountryMetricsQuery({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useAllActivePartnerCountryMetricsQuery(baseOptions: Apollo.QueryHookOptions<AllActivePartnerCountryMetricsQuery, AllActivePartnerCountryMetricsQueryVariables> & ({ variables: AllActivePartnerCountryMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllActivePartnerCountryMetricsQuery, AllActivePartnerCountryMetricsQueryVariables>(AllActivePartnerCountryMetricsDocument, options);
      }
export function useAllActivePartnerCountryMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllActivePartnerCountryMetricsQuery, AllActivePartnerCountryMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllActivePartnerCountryMetricsQuery, AllActivePartnerCountryMetricsQueryVariables>(AllActivePartnerCountryMetricsDocument, options);
        }
// @ts-ignore
export function useAllActivePartnerCountryMetricsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllActivePartnerCountryMetricsQuery, AllActivePartnerCountryMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<AllActivePartnerCountryMetricsQuery, AllActivePartnerCountryMetricsQueryVariables>;
export function useAllActivePartnerCountryMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllActivePartnerCountryMetricsQuery, AllActivePartnerCountryMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<AllActivePartnerCountryMetricsQuery | undefined, AllActivePartnerCountryMetricsQueryVariables>;
export function useAllActivePartnerCountryMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllActivePartnerCountryMetricsQuery, AllActivePartnerCountryMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllActivePartnerCountryMetricsQuery, AllActivePartnerCountryMetricsQueryVariables>(AllActivePartnerCountryMetricsDocument, options);
        }
export type AllActivePartnerCountryMetricsQueryHookResult = ReturnType<typeof useAllActivePartnerCountryMetricsQuery>;
export type AllActivePartnerCountryMetricsLazyQueryHookResult = ReturnType<typeof useAllActivePartnerCountryMetricsLazyQuery>;
export type AllActivePartnerCountryMetricsSuspenseQueryHookResult = ReturnType<typeof useAllActivePartnerCountryMetricsSuspenseQuery>;
export type AllActivePartnerCountryMetricsQueryResult = Apollo.QueryResult<AllActivePartnerCountryMetricsQuery, AllActivePartnerCountryMetricsQueryVariables>;
export const EimExecutiveDashboardDocument = gql`
    query eimExecutiveDashboard($request: EIMExecutiveDashboardRequest!) {
  eimExecutiveDashboard(request: $request) {
    volume {
      totalProcessed
      inboundCount
      outboundCount
      previousPeriodTotal
      volumeDelta
      failedCount
      inTransitCount
      busnTransitCount
      failureRate
      failureRateTarget
      failureRateThreshold
      volumeTrendByMonth {
        month
        total
        failed
        stpRate
      }
    }
    flowHealth {
      stpRate
      previousStpRate
      stpDelta
      stpTarget
      stpThreshold
      onTimeRate
      previousOnTimeRate
      onTimeDelta
      onTimeTarget
      onTimeThreshold
      avgTransitDays
      previousAvgTransitDays
      transitDelta
      stpRateTrendByMonth {
        month
        stpRate
        onTimeRate
        avgTransitDays
      }
      stpRateTrendByDay {
        month
        stpRate
        onTimeRate
        avgTransitDays
      }
      stpRateTrendByYear {
        month
        stpRate
        onTimeRate
        avgTransitDays
      }
    }
    risk {
      overdueCount
      previousOverdueCount
      overdueDelta
      overdueTarget
      overdueThreshold
      failedCount
      failureRate
      previousFailureRate
      failureRateDelta
      failureRateTarget
      failureRateThreshold
      agingBuckets {
        ageRange
        count
        percentage
      }
      overdueTrendByMonth {
        month
        overdueCount
      }
    }
    coverage {
      activePartners
      totalPartners
      coverageRate
      previousCoverageRate
      coverageDelta
      coverageTarget
      coverageThreshold
      monthlyNewPartners
      topImpactedGroups {
        groupName
        failureRate
        overdueCount
        volume
        riskRanking
      }
      coverageTrendByMonth {
        month
        coverageRate
        activePartnerCount
      }
    }
    metadata {
      dataAsOf
      lastRefresh
      appliedFilters {
        periodStart
        periodEnd
        processType
        partnerGroup
      }
      compositeHealthScore
      healthScoreLabel
    }
  }
}
    `;

/**
 * __useEimExecutiveDashboardQuery__
 *
 * To run a query within a React component, call `useEimExecutiveDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useEimExecutiveDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEimExecutiveDashboardQuery({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useEimExecutiveDashboardQuery(baseOptions: Apollo.QueryHookOptions<EimExecutiveDashboardQuery, EimExecutiveDashboardQueryVariables> & ({ variables: EimExecutiveDashboardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EimExecutiveDashboardQuery, EimExecutiveDashboardQueryVariables>(EimExecutiveDashboardDocument, options);
      }
export function useEimExecutiveDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EimExecutiveDashboardQuery, EimExecutiveDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EimExecutiveDashboardQuery, EimExecutiveDashboardQueryVariables>(EimExecutiveDashboardDocument, options);
        }
// @ts-ignore
export function useEimExecutiveDashboardSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EimExecutiveDashboardQuery, EimExecutiveDashboardQueryVariables>): Apollo.UseSuspenseQueryResult<EimExecutiveDashboardQuery, EimExecutiveDashboardQueryVariables>;
export function useEimExecutiveDashboardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EimExecutiveDashboardQuery, EimExecutiveDashboardQueryVariables>): Apollo.UseSuspenseQueryResult<EimExecutiveDashboardQuery | undefined, EimExecutiveDashboardQueryVariables>;
export function useEimExecutiveDashboardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EimExecutiveDashboardQuery, EimExecutiveDashboardQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EimExecutiveDashboardQuery, EimExecutiveDashboardQueryVariables>(EimExecutiveDashboardDocument, options);
        }
export type EimExecutiveDashboardQueryHookResult = ReturnType<typeof useEimExecutiveDashboardQuery>;
export type EimExecutiveDashboardLazyQueryHookResult = ReturnType<typeof useEimExecutiveDashboardLazyQuery>;
export type EimExecutiveDashboardSuspenseQueryHookResult = ReturnType<typeof useEimExecutiveDashboardSuspenseQuery>;
export type EimExecutiveDashboardQueryResult = Apollo.QueryResult<EimExecutiveDashboardQuery, EimExecutiveDashboardQueryVariables>;
export const EimExecutiveDashboardV2Document = gql`
    query eimExecutiveDashboardV2($request: EIMExecutiveDashboardRequest!) {
  eimExecutiveDashboard(request: $request) {
    volume {
      totalProcessed
    }
    flowHealth {
      onTimeRate
      onTimeDelta
      avgTransitDays
    }
    coverage {
      coverageRate
      coverageThreshold
    }
    metadata {
      healthScoreLabel
    }
  }
}
    `;

/**
 * __useEimExecutiveDashboardV2Query__
 *
 * To run a query within a React component, call `useEimExecutiveDashboardV2Query` and pass it any options that fit your needs.
 * When your component renders, `useEimExecutiveDashboardV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEimExecutiveDashboardV2Query({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useEimExecutiveDashboardV2Query(baseOptions: Apollo.QueryHookOptions<EimExecutiveDashboardV2Query, EimExecutiveDashboardV2QueryVariables> & ({ variables: EimExecutiveDashboardV2QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EimExecutiveDashboardV2Query, EimExecutiveDashboardV2QueryVariables>(EimExecutiveDashboardV2Document, options);
      }
export function useEimExecutiveDashboardV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EimExecutiveDashboardV2Query, EimExecutiveDashboardV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EimExecutiveDashboardV2Query, EimExecutiveDashboardV2QueryVariables>(EimExecutiveDashboardV2Document, options);
        }
// @ts-ignore
export function useEimExecutiveDashboardV2SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EimExecutiveDashboardV2Query, EimExecutiveDashboardV2QueryVariables>): Apollo.UseSuspenseQueryResult<EimExecutiveDashboardV2Query, EimExecutiveDashboardV2QueryVariables>;
export function useEimExecutiveDashboardV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EimExecutiveDashboardV2Query, EimExecutiveDashboardV2QueryVariables>): Apollo.UseSuspenseQueryResult<EimExecutiveDashboardV2Query | undefined, EimExecutiveDashboardV2QueryVariables>;
export function useEimExecutiveDashboardV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EimExecutiveDashboardV2Query, EimExecutiveDashboardV2QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EimExecutiveDashboardV2Query, EimExecutiveDashboardV2QueryVariables>(EimExecutiveDashboardV2Document, options);
        }
export type EimExecutiveDashboardV2QueryHookResult = ReturnType<typeof useEimExecutiveDashboardV2Query>;
export type EimExecutiveDashboardV2LazyQueryHookResult = ReturnType<typeof useEimExecutiveDashboardV2LazyQuery>;
export type EimExecutiveDashboardV2SuspenseQueryHookResult = ReturnType<typeof useEimExecutiveDashboardV2SuspenseQuery>;
export type EimExecutiveDashboardV2QueryResult = Apollo.QueryResult<EimExecutiveDashboardV2Query, EimExecutiveDashboardV2QueryVariables>;
export const EimExecutiveDashboardCountryMetricsDocument = gql`
    query eimExecutiveDashboardCountryMetrics($request: EIMExecutiveDashboardRequest!) {
  eimExecutiveDashboardCountryMetrics(request: $request) {
    country
    companyCode
    intake {
      totalProcessed
      inboundCount
      outboundCount
    }
    processing {
      stpRate
      onTimeRate
      avgTransitDays
      inTransitCount
    }
    exceptions {
      failedCount
      overdueCount
      failureRate
    }
    coverage {
      activePartners
      totalPartners
      coverageRate
    }
  }
}
    `;

/**
 * __useEimExecutiveDashboardCountryMetricsQuery__
 *
 * To run a query within a React component, call `useEimExecutiveDashboardCountryMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEimExecutiveDashboardCountryMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEimExecutiveDashboardCountryMetricsQuery({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useEimExecutiveDashboardCountryMetricsQuery(baseOptions: Apollo.QueryHookOptions<EimExecutiveDashboardCountryMetricsQuery, EimExecutiveDashboardCountryMetricsQueryVariables> & ({ variables: EimExecutiveDashboardCountryMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EimExecutiveDashboardCountryMetricsQuery, EimExecutiveDashboardCountryMetricsQueryVariables>(EimExecutiveDashboardCountryMetricsDocument, options);
      }
export function useEimExecutiveDashboardCountryMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EimExecutiveDashboardCountryMetricsQuery, EimExecutiveDashboardCountryMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EimExecutiveDashboardCountryMetricsQuery, EimExecutiveDashboardCountryMetricsQueryVariables>(EimExecutiveDashboardCountryMetricsDocument, options);
        }
// @ts-ignore
export function useEimExecutiveDashboardCountryMetricsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EimExecutiveDashboardCountryMetricsQuery, EimExecutiveDashboardCountryMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<EimExecutiveDashboardCountryMetricsQuery, EimExecutiveDashboardCountryMetricsQueryVariables>;
export function useEimExecutiveDashboardCountryMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EimExecutiveDashboardCountryMetricsQuery, EimExecutiveDashboardCountryMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<EimExecutiveDashboardCountryMetricsQuery | undefined, EimExecutiveDashboardCountryMetricsQueryVariables>;
export function useEimExecutiveDashboardCountryMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EimExecutiveDashboardCountryMetricsQuery, EimExecutiveDashboardCountryMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EimExecutiveDashboardCountryMetricsQuery, EimExecutiveDashboardCountryMetricsQueryVariables>(EimExecutiveDashboardCountryMetricsDocument, options);
        }
export type EimExecutiveDashboardCountryMetricsQueryHookResult = ReturnType<typeof useEimExecutiveDashboardCountryMetricsQuery>;
export type EimExecutiveDashboardCountryMetricsLazyQueryHookResult = ReturnType<typeof useEimExecutiveDashboardCountryMetricsLazyQuery>;
export type EimExecutiveDashboardCountryMetricsSuspenseQueryHookResult = ReturnType<typeof useEimExecutiveDashboardCountryMetricsSuspenseQuery>;
export type EimExecutiveDashboardCountryMetricsQueryResult = Apollo.QueryResult<EimExecutiveDashboardCountryMetricsQuery, EimExecutiveDashboardCountryMetricsQueryVariables>;
export const EimExecutiveDashboardSystemMetricsDocument = gql`
    query eimExecutiveDashboardSystemMetrics($request: EIMExecutiveDashboardRequest!) {
  eimExecutiveDashboardSystemMetrics(request: $request) {
    systemId
    systemLabel
    intake {
      totalProcessed
      inboundCount
      outboundCount
    }
    processing {
      stpRate
      onTimeRate
      avgTransitDays
      inTransitCount
    }
    exceptions {
      failedCount
      overdueCount
      failureRate
    }
    coverage {
      activePartners
      totalPartners
      coverageRate
    }
  }
}
    `;

/**
 * __useEimExecutiveDashboardSystemMetricsQuery__
 *
 * To run a query within a React component, call `useEimExecutiveDashboardSystemMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEimExecutiveDashboardSystemMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEimExecutiveDashboardSystemMetricsQuery({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useEimExecutiveDashboardSystemMetricsQuery(baseOptions: Apollo.QueryHookOptions<EimExecutiveDashboardSystemMetricsQuery, EimExecutiveDashboardSystemMetricsQueryVariables> & ({ variables: EimExecutiveDashboardSystemMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EimExecutiveDashboardSystemMetricsQuery, EimExecutiveDashboardSystemMetricsQueryVariables>(EimExecutiveDashboardSystemMetricsDocument, options);
      }
export function useEimExecutiveDashboardSystemMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EimExecutiveDashboardSystemMetricsQuery, EimExecutiveDashboardSystemMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EimExecutiveDashboardSystemMetricsQuery, EimExecutiveDashboardSystemMetricsQueryVariables>(EimExecutiveDashboardSystemMetricsDocument, options);
        }
// @ts-ignore
export function useEimExecutiveDashboardSystemMetricsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EimExecutiveDashboardSystemMetricsQuery, EimExecutiveDashboardSystemMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<EimExecutiveDashboardSystemMetricsQuery, EimExecutiveDashboardSystemMetricsQueryVariables>;
export function useEimExecutiveDashboardSystemMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EimExecutiveDashboardSystemMetricsQuery, EimExecutiveDashboardSystemMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<EimExecutiveDashboardSystemMetricsQuery | undefined, EimExecutiveDashboardSystemMetricsQueryVariables>;
export function useEimExecutiveDashboardSystemMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EimExecutiveDashboardSystemMetricsQuery, EimExecutiveDashboardSystemMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EimExecutiveDashboardSystemMetricsQuery, EimExecutiveDashboardSystemMetricsQueryVariables>(EimExecutiveDashboardSystemMetricsDocument, options);
        }
export type EimExecutiveDashboardSystemMetricsQueryHookResult = ReturnType<typeof useEimExecutiveDashboardSystemMetricsQuery>;
export type EimExecutiveDashboardSystemMetricsLazyQueryHookResult = ReturnType<typeof useEimExecutiveDashboardSystemMetricsLazyQuery>;
export type EimExecutiveDashboardSystemMetricsSuspenseQueryHookResult = ReturnType<typeof useEimExecutiveDashboardSystemMetricsSuspenseQuery>;
export type EimExecutiveDashboardSystemMetricsQueryResult = Apollo.QueryResult<EimExecutiveDashboardSystemMetricsQuery, EimExecutiveDashboardSystemMetricsQueryVariables>;
export const EimExecutiveDashboardChannelMetricsDocument = gql`
    query eimExecutiveDashboardChannelMetrics($request: EIMExecutiveDashboardRequest!) {
  eimExecutiveDashboardChannelMetrics(request: $request) {
    channel
    intake {
      totalProcessed
      inboundCount
      outboundCount
    }
    processing {
      stpRate
      onTimeRate
      avgTransitDays
      inTransitCount
    }
    exceptions {
      failedCount
      overdueCount
      failureRate
    }
    coverage {
      activePartners
      totalPartners
      coverageRate
    }
  }
}
    `;

/**
 * __useEimExecutiveDashboardChannelMetricsQuery__
 *
 * To run a query within a React component, call `useEimExecutiveDashboardChannelMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEimExecutiveDashboardChannelMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEimExecutiveDashboardChannelMetricsQuery({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useEimExecutiveDashboardChannelMetricsQuery(baseOptions: Apollo.QueryHookOptions<EimExecutiveDashboardChannelMetricsQuery, EimExecutiveDashboardChannelMetricsQueryVariables> & ({ variables: EimExecutiveDashboardChannelMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EimExecutiveDashboardChannelMetricsQuery, EimExecutiveDashboardChannelMetricsQueryVariables>(EimExecutiveDashboardChannelMetricsDocument, options);
      }
export function useEimExecutiveDashboardChannelMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EimExecutiveDashboardChannelMetricsQuery, EimExecutiveDashboardChannelMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EimExecutiveDashboardChannelMetricsQuery, EimExecutiveDashboardChannelMetricsQueryVariables>(EimExecutiveDashboardChannelMetricsDocument, options);
        }
// @ts-ignore
export function useEimExecutiveDashboardChannelMetricsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EimExecutiveDashboardChannelMetricsQuery, EimExecutiveDashboardChannelMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<EimExecutiveDashboardChannelMetricsQuery, EimExecutiveDashboardChannelMetricsQueryVariables>;
export function useEimExecutiveDashboardChannelMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EimExecutiveDashboardChannelMetricsQuery, EimExecutiveDashboardChannelMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<EimExecutiveDashboardChannelMetricsQuery | undefined, EimExecutiveDashboardChannelMetricsQueryVariables>;
export function useEimExecutiveDashboardChannelMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EimExecutiveDashboardChannelMetricsQuery, EimExecutiveDashboardChannelMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EimExecutiveDashboardChannelMetricsQuery, EimExecutiveDashboardChannelMetricsQueryVariables>(EimExecutiveDashboardChannelMetricsDocument, options);
        }
export type EimExecutiveDashboardChannelMetricsQueryHookResult = ReturnType<typeof useEimExecutiveDashboardChannelMetricsQuery>;
export type EimExecutiveDashboardChannelMetricsLazyQueryHookResult = ReturnType<typeof useEimExecutiveDashboardChannelMetricsLazyQuery>;
export type EimExecutiveDashboardChannelMetricsSuspenseQueryHookResult = ReturnType<typeof useEimExecutiveDashboardChannelMetricsSuspenseQuery>;
export type EimExecutiveDashboardChannelMetricsQueryResult = Apollo.QueryResult<EimExecutiveDashboardChannelMetricsQuery, EimExecutiveDashboardChannelMetricsQueryVariables>;
export const EimExecutiveDashboardFlowStageMetricsDocument = gql`
    query eimExecutiveDashboardFlowStageMetrics($request: EIMExecutiveDashboardRequest!) {
  eimExecutiveDashboardFlowStageMetrics(request: $request) {
    mProcess
    stage
    stepNumber
    transitionCount
    avgTransitDays
  }
}
    `;

/**
 * __useEimExecutiveDashboardFlowStageMetricsQuery__
 *
 * To run a query within a React component, call `useEimExecutiveDashboardFlowStageMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEimExecutiveDashboardFlowStageMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEimExecutiveDashboardFlowStageMetricsQuery({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useEimExecutiveDashboardFlowStageMetricsQuery(baseOptions: Apollo.QueryHookOptions<EimExecutiveDashboardFlowStageMetricsQuery, EimExecutiveDashboardFlowStageMetricsQueryVariables> & ({ variables: EimExecutiveDashboardFlowStageMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EimExecutiveDashboardFlowStageMetricsQuery, EimExecutiveDashboardFlowStageMetricsQueryVariables>(EimExecutiveDashboardFlowStageMetricsDocument, options);
      }
export function useEimExecutiveDashboardFlowStageMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EimExecutiveDashboardFlowStageMetricsQuery, EimExecutiveDashboardFlowStageMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EimExecutiveDashboardFlowStageMetricsQuery, EimExecutiveDashboardFlowStageMetricsQueryVariables>(EimExecutiveDashboardFlowStageMetricsDocument, options);
        }
// @ts-ignore
export function useEimExecutiveDashboardFlowStageMetricsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EimExecutiveDashboardFlowStageMetricsQuery, EimExecutiveDashboardFlowStageMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<EimExecutiveDashboardFlowStageMetricsQuery, EimExecutiveDashboardFlowStageMetricsQueryVariables>;
export function useEimExecutiveDashboardFlowStageMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EimExecutiveDashboardFlowStageMetricsQuery, EimExecutiveDashboardFlowStageMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<EimExecutiveDashboardFlowStageMetricsQuery | undefined, EimExecutiveDashboardFlowStageMetricsQueryVariables>;
export function useEimExecutiveDashboardFlowStageMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EimExecutiveDashboardFlowStageMetricsQuery, EimExecutiveDashboardFlowStageMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EimExecutiveDashboardFlowStageMetricsQuery, EimExecutiveDashboardFlowStageMetricsQueryVariables>(EimExecutiveDashboardFlowStageMetricsDocument, options);
        }
export type EimExecutiveDashboardFlowStageMetricsQueryHookResult = ReturnType<typeof useEimExecutiveDashboardFlowStageMetricsQuery>;
export type EimExecutiveDashboardFlowStageMetricsLazyQueryHookResult = ReturnType<typeof useEimExecutiveDashboardFlowStageMetricsLazyQuery>;
export type EimExecutiveDashboardFlowStageMetricsSuspenseQueryHookResult = ReturnType<typeof useEimExecutiveDashboardFlowStageMetricsSuspenseQuery>;
export type EimExecutiveDashboardFlowStageMetricsQueryResult = Apollo.QueryResult<EimExecutiveDashboardFlowStageMetricsQuery, EimExecutiveDashboardFlowStageMetricsQueryVariables>;
export const EimExecutiveDashboardGroupMetricsDocument = gql`
    query eimExecutiveDashboardGroupMetrics($request: EIMExecutiveDashboardRequest!) {
  eimExecutiveDashboardGroupMetrics(request: $request) {
    groupName
    country
    totalInvoices
    successfulCount
    inTransitCount
    failedCount
  }
}
    `;

/**
 * __useEimExecutiveDashboardGroupMetricsQuery__
 *
 * To run a query within a React component, call `useEimExecutiveDashboardGroupMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEimExecutiveDashboardGroupMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEimExecutiveDashboardGroupMetricsQuery({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useEimExecutiveDashboardGroupMetricsQuery(baseOptions: Apollo.QueryHookOptions<EimExecutiveDashboardGroupMetricsQuery, EimExecutiveDashboardGroupMetricsQueryVariables> & ({ variables: EimExecutiveDashboardGroupMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EimExecutiveDashboardGroupMetricsQuery, EimExecutiveDashboardGroupMetricsQueryVariables>(EimExecutiveDashboardGroupMetricsDocument, options);
      }
export function useEimExecutiveDashboardGroupMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EimExecutiveDashboardGroupMetricsQuery, EimExecutiveDashboardGroupMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EimExecutiveDashboardGroupMetricsQuery, EimExecutiveDashboardGroupMetricsQueryVariables>(EimExecutiveDashboardGroupMetricsDocument, options);
        }
// @ts-ignore
export function useEimExecutiveDashboardGroupMetricsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EimExecutiveDashboardGroupMetricsQuery, EimExecutiveDashboardGroupMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<EimExecutiveDashboardGroupMetricsQuery, EimExecutiveDashboardGroupMetricsQueryVariables>;
export function useEimExecutiveDashboardGroupMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EimExecutiveDashboardGroupMetricsQuery, EimExecutiveDashboardGroupMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<EimExecutiveDashboardGroupMetricsQuery | undefined, EimExecutiveDashboardGroupMetricsQueryVariables>;
export function useEimExecutiveDashboardGroupMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EimExecutiveDashboardGroupMetricsQuery, EimExecutiveDashboardGroupMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EimExecutiveDashboardGroupMetricsQuery, EimExecutiveDashboardGroupMetricsQueryVariables>(EimExecutiveDashboardGroupMetricsDocument, options);
        }
export type EimExecutiveDashboardGroupMetricsQueryHookResult = ReturnType<typeof useEimExecutiveDashboardGroupMetricsQuery>;
export type EimExecutiveDashboardGroupMetricsLazyQueryHookResult = ReturnType<typeof useEimExecutiveDashboardGroupMetricsLazyQuery>;
export type EimExecutiveDashboardGroupMetricsSuspenseQueryHookResult = ReturnType<typeof useEimExecutiveDashboardGroupMetricsSuspenseQuery>;
export type EimExecutiveDashboardGroupMetricsQueryResult = Apollo.QueryResult<EimExecutiveDashboardGroupMetricsQuery, EimExecutiveDashboardGroupMetricsQueryVariables>;
export const EimExecutiveDashboardTopFailureReasonsDocument = gql`
    query eimExecutiveDashboardTopFailureReasons($request: EIMExecutiveDashboardRequest!) {
  eimExecutiveDashboardTopFailureReasons(request: $request) {
    reason
    invoiceCount
    percentage
    failedCount
    failureRate
    overdueCount
    volume
  }
}
    `;

/**
 * __useEimExecutiveDashboardTopFailureReasonsQuery__
 *
 * To run a query within a React component, call `useEimExecutiveDashboardTopFailureReasonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEimExecutiveDashboardTopFailureReasonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEimExecutiveDashboardTopFailureReasonsQuery({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useEimExecutiveDashboardTopFailureReasonsQuery(baseOptions: Apollo.QueryHookOptions<EimExecutiveDashboardTopFailureReasonsQuery, EimExecutiveDashboardTopFailureReasonsQueryVariables> & ({ variables: EimExecutiveDashboardTopFailureReasonsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EimExecutiveDashboardTopFailureReasonsQuery, EimExecutiveDashboardTopFailureReasonsQueryVariables>(EimExecutiveDashboardTopFailureReasonsDocument, options);
      }
export function useEimExecutiveDashboardTopFailureReasonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EimExecutiveDashboardTopFailureReasonsQuery, EimExecutiveDashboardTopFailureReasonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EimExecutiveDashboardTopFailureReasonsQuery, EimExecutiveDashboardTopFailureReasonsQueryVariables>(EimExecutiveDashboardTopFailureReasonsDocument, options);
        }
// @ts-ignore
export function useEimExecutiveDashboardTopFailureReasonsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EimExecutiveDashboardTopFailureReasonsQuery, EimExecutiveDashboardTopFailureReasonsQueryVariables>): Apollo.UseSuspenseQueryResult<EimExecutiveDashboardTopFailureReasonsQuery, EimExecutiveDashboardTopFailureReasonsQueryVariables>;
export function useEimExecutiveDashboardTopFailureReasonsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EimExecutiveDashboardTopFailureReasonsQuery, EimExecutiveDashboardTopFailureReasonsQueryVariables>): Apollo.UseSuspenseQueryResult<EimExecutiveDashboardTopFailureReasonsQuery | undefined, EimExecutiveDashboardTopFailureReasonsQueryVariables>;
export function useEimExecutiveDashboardTopFailureReasonsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EimExecutiveDashboardTopFailureReasonsQuery, EimExecutiveDashboardTopFailureReasonsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EimExecutiveDashboardTopFailureReasonsQuery, EimExecutiveDashboardTopFailureReasonsQueryVariables>(EimExecutiveDashboardTopFailureReasonsDocument, options);
        }
export type EimExecutiveDashboardTopFailureReasonsQueryHookResult = ReturnType<typeof useEimExecutiveDashboardTopFailureReasonsQuery>;
export type EimExecutiveDashboardTopFailureReasonsLazyQueryHookResult = ReturnType<typeof useEimExecutiveDashboardTopFailureReasonsLazyQuery>;
export type EimExecutiveDashboardTopFailureReasonsSuspenseQueryHookResult = ReturnType<typeof useEimExecutiveDashboardTopFailureReasonsSuspenseQuery>;
export type EimExecutiveDashboardTopFailureReasonsQueryResult = Apollo.QueryResult<EimExecutiveDashboardTopFailureReasonsQuery, EimExecutiveDashboardTopFailureReasonsQueryVariables>;
export const EimExecutiveDashboardTopFailureProcessesDocument = gql`
    query eimExecutiveDashboardTopFailureProcesses($request: EIMExecutiveDashboardRequest!) {
  eimExecutiveDashboardTopFailureProcesses(request: $request) {
    process
    failedCount
    totalCount
    failureRate
    overdueCount
  }
}
    `;

/**
 * __useEimExecutiveDashboardTopFailureProcessesQuery__
 *
 * To run a query within a React component, call `useEimExecutiveDashboardTopFailureProcessesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEimExecutiveDashboardTopFailureProcessesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEimExecutiveDashboardTopFailureProcessesQuery({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useEimExecutiveDashboardTopFailureProcessesQuery(baseOptions: Apollo.QueryHookOptions<EimExecutiveDashboardTopFailureProcessesQuery, EimExecutiveDashboardTopFailureProcessesQueryVariables> & ({ variables: EimExecutiveDashboardTopFailureProcessesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EimExecutiveDashboardTopFailureProcessesQuery, EimExecutiveDashboardTopFailureProcessesQueryVariables>(EimExecutiveDashboardTopFailureProcessesDocument, options);
      }
export function useEimExecutiveDashboardTopFailureProcessesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EimExecutiveDashboardTopFailureProcessesQuery, EimExecutiveDashboardTopFailureProcessesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EimExecutiveDashboardTopFailureProcessesQuery, EimExecutiveDashboardTopFailureProcessesQueryVariables>(EimExecutiveDashboardTopFailureProcessesDocument, options);
        }
// @ts-ignore
export function useEimExecutiveDashboardTopFailureProcessesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EimExecutiveDashboardTopFailureProcessesQuery, EimExecutiveDashboardTopFailureProcessesQueryVariables>): Apollo.UseSuspenseQueryResult<EimExecutiveDashboardTopFailureProcessesQuery, EimExecutiveDashboardTopFailureProcessesQueryVariables>;
export function useEimExecutiveDashboardTopFailureProcessesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EimExecutiveDashboardTopFailureProcessesQuery, EimExecutiveDashboardTopFailureProcessesQueryVariables>): Apollo.UseSuspenseQueryResult<EimExecutiveDashboardTopFailureProcessesQuery | undefined, EimExecutiveDashboardTopFailureProcessesQueryVariables>;
export function useEimExecutiveDashboardTopFailureProcessesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EimExecutiveDashboardTopFailureProcessesQuery, EimExecutiveDashboardTopFailureProcessesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EimExecutiveDashboardTopFailureProcessesQuery, EimExecutiveDashboardTopFailureProcessesQueryVariables>(EimExecutiveDashboardTopFailureProcessesDocument, options);
        }
export type EimExecutiveDashboardTopFailureProcessesQueryHookResult = ReturnType<typeof useEimExecutiveDashboardTopFailureProcessesQuery>;
export type EimExecutiveDashboardTopFailureProcessesLazyQueryHookResult = ReturnType<typeof useEimExecutiveDashboardTopFailureProcessesLazyQuery>;
export type EimExecutiveDashboardTopFailureProcessesSuspenseQueryHookResult = ReturnType<typeof useEimExecutiveDashboardTopFailureProcessesSuspenseQuery>;
export type EimExecutiveDashboardTopFailureProcessesQueryResult = Apollo.QueryResult<EimExecutiveDashboardTopFailureProcessesQuery, EimExecutiveDashboardTopFailureProcessesQueryVariables>;
export const EimExecutiveDashboardTopFailureCompanyCodesDocument = gql`
    query eimExecutiveDashboardTopFailureCompanyCodes($request: EIMExecutiveDashboardRequest!) {
  eimExecutiveDashboardTopFailureCompanyCodes(request: $request) {
    companyCode
    country
    failureRate
    overdueCount
    volume
    riskRanking
  }
}
    `;

/**
 * __useEimExecutiveDashboardTopFailureCompanyCodesQuery__
 *
 * To run a query within a React component, call `useEimExecutiveDashboardTopFailureCompanyCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEimExecutiveDashboardTopFailureCompanyCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEimExecutiveDashboardTopFailureCompanyCodesQuery({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useEimExecutiveDashboardTopFailureCompanyCodesQuery(baseOptions: Apollo.QueryHookOptions<EimExecutiveDashboardTopFailureCompanyCodesQuery, EimExecutiveDashboardTopFailureCompanyCodesQueryVariables> & ({ variables: EimExecutiveDashboardTopFailureCompanyCodesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EimExecutiveDashboardTopFailureCompanyCodesQuery, EimExecutiveDashboardTopFailureCompanyCodesQueryVariables>(EimExecutiveDashboardTopFailureCompanyCodesDocument, options);
      }
export function useEimExecutiveDashboardTopFailureCompanyCodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EimExecutiveDashboardTopFailureCompanyCodesQuery, EimExecutiveDashboardTopFailureCompanyCodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EimExecutiveDashboardTopFailureCompanyCodesQuery, EimExecutiveDashboardTopFailureCompanyCodesQueryVariables>(EimExecutiveDashboardTopFailureCompanyCodesDocument, options);
        }
// @ts-ignore
export function useEimExecutiveDashboardTopFailureCompanyCodesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EimExecutiveDashboardTopFailureCompanyCodesQuery, EimExecutiveDashboardTopFailureCompanyCodesQueryVariables>): Apollo.UseSuspenseQueryResult<EimExecutiveDashboardTopFailureCompanyCodesQuery, EimExecutiveDashboardTopFailureCompanyCodesQueryVariables>;
export function useEimExecutiveDashboardTopFailureCompanyCodesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EimExecutiveDashboardTopFailureCompanyCodesQuery, EimExecutiveDashboardTopFailureCompanyCodesQueryVariables>): Apollo.UseSuspenseQueryResult<EimExecutiveDashboardTopFailureCompanyCodesQuery | undefined, EimExecutiveDashboardTopFailureCompanyCodesQueryVariables>;
export function useEimExecutiveDashboardTopFailureCompanyCodesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EimExecutiveDashboardTopFailureCompanyCodesQuery, EimExecutiveDashboardTopFailureCompanyCodesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EimExecutiveDashboardTopFailureCompanyCodesQuery, EimExecutiveDashboardTopFailureCompanyCodesQueryVariables>(EimExecutiveDashboardTopFailureCompanyCodesDocument, options);
        }
export type EimExecutiveDashboardTopFailureCompanyCodesQueryHookResult = ReturnType<typeof useEimExecutiveDashboardTopFailureCompanyCodesQuery>;
export type EimExecutiveDashboardTopFailureCompanyCodesLazyQueryHookResult = ReturnType<typeof useEimExecutiveDashboardTopFailureCompanyCodesLazyQuery>;
export type EimExecutiveDashboardTopFailureCompanyCodesSuspenseQueryHookResult = ReturnType<typeof useEimExecutiveDashboardTopFailureCompanyCodesSuspenseQuery>;
export type EimExecutiveDashboardTopFailureCompanyCodesQueryResult = Apollo.QueryResult<EimExecutiveDashboardTopFailureCompanyCodesQuery, EimExecutiveDashboardTopFailureCompanyCodesQueryVariables>;